//import "jquery";
//import "./ui-select.js";

export default function () {

  return {
    restrict: "EA",
    scope: {
      onSelect: "&?"
    },
    //templateUrl : "modules/common/directives/portlet/portlet.tpl.html",
    link: function (scope, elem, attrs) {
      //console.log("create dcSelect");
      var e = $(elem).dcSelect();
    }
  };

};



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-select/dc-select.js